import React, { useState } from "react";
import { IssueAPI } from "../api/apiClient";
import { useAuth } from "../context/AuthContext";
// details page 
//import { Issue } from "../types/issue";

export default function NewIssueModal({
  projectId,
  onClose,
  onCreated,
}: {
  projectId: number;
  onClose: () => void;
  onCreated: (issue: any) => void;
}) {
  const { user } = useAuth();
  

  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const [loading, setLoading] = useState(false);

  const TITLE_MAX_LENGTH = 50;

  // auto dates
  const today = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);

  /* const handleCreate = async () => {
    if (!title.trim() || !user) return; 

    setLoading(true);
 */

    const handleCreate = async () => { 
  if (!title.trim() || !user) return;

  if (title.length > TITLE_MAX_LENGTH) {
    alert("Issue title exceeds the 50 character limit. Please reduce the length.");
    return;
  }

  setLoading(true);

    const dto = {
      title,
      description: desc,
      createdBy: user.userNo,  // ✅ taskOwner automatically inferred backend
      dueDate: tomorrow.toISOString(), // ✅ auto due tomorrow
      duration: 1, // ✅ default duration 1 day
      startDate: today.toISOString(), // ✅ default start today
    };

    try {
      const issue = await IssueAPI.create(projectId, dto);
      //details page show
     
      const goToDetails = window.confirm(
      "Issue created successfully.\n\nDo you want to go to the details page?"
    );

    if (goToDetails) {
      onCreated(issue); // MainView will open details
    } else {
      onClose(); // stay where you are
    }

      
    } catch {
      alert("Failed to create issue");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded shadow-lg w-96 space-y-4">

        <h2 className="text-lg font-semibold">Create New Issue</h2>

       {/*  <input
          className="border p-2 rounded w-full"
          placeholder="Issue title *"
          autoFocus
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        /> */}

        <div>
  <input
    className={`border p-2 rounded w-full ${
      title.length > TITLE_MAX_LENGTH ? "border-red-500" : ""
    }`}
    placeholder="Issue title *"
    autoFocus
    value={title}
    onChange={(e) => setTitle(e.target.value)}
  />

  <div className="flex justify-between mt-1">
    <span
      className={`text-xs ${
        title.length > TITLE_MAX_LENGTH
          ? "text-red-600 font-medium"
          : "text-gray-500"
      }`}
    >
      {title.length > TITLE_MAX_LENGTH
        ? "⚠️ Character limit exceeded. Reduce the length."
        : "Issue title"}
    </span>

    <span
      className={`text-xs ${
        title.length > TITLE_MAX_LENGTH
          ? "text-red-600 font-medium"
          : "text-gray-500"
      }`}
    >
      {title.length}/{TITLE_MAX_LENGTH}
    </span>
  </div>
</div>

        <textarea
          className="border p-2 rounded w-full"
          placeholder="Description (optional)"
          rows={3}
          value={desc}
          onChange={(e) => setDesc(e.target.value)}
        />

        <div className="text-xs text-gray-500">
          ✅ Due tomorrow • Duration 1 day • Starts today
        </div>

        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-3 py-1 rounded bg-gray-200"
          >
            Cancel
          </button>

          <button
            onClick={handleCreate}
            // disabled={!title.trim() || loading}
            disabled={
  !title.trim() ||
  title.length > TITLE_MAX_LENGTH ||
  loading
}
            className={`px-4 py-1 rounded text-white ${
             
              title.trim() && title.length <= TITLE_MAX_LENGTH
                ? "bg-blue-600 hover:bg-blue-700"
                : "bg-gray-400 cursor-not-allowed"
            }`}
          >
            {loading ? "Creating..." : "Create and Go to Details Page"}
          </button>
        </div>
      </div>
    </div>
  );
}
